import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custservice',
  templateUrl: './custservice.component.html',
  styleUrls: ['./custservice.component.css']
})
export class CustserviceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
